<template>
    <nav class="meta-navigation">
        <ul class="meta-navigation--collection u-reset">
            <li class="meta-navigation--item" v-for="(item, index) in items" :key="index">
                <router-link class="meta-navigation--link u-reset" :to="item.path">
                    {{ item.label }}
                </router-link>
            </li>
        </ul>
    </nav>
</template>

<script>
    export default {
        props: {
            /** @type {ILink[]} */
            children: {
                type: Array,
                required: true,
            },
        },
        computed: {
            /** @type {ILink[]} */
            items: {
                get() {
                    return this.children.map(item => item.content);
                },
            },
        },
    };
</script>
